import React from 'react';
import styled from 'styled-components';
import { formatDate } from '../../utils/date';

const StyledTableCell = styled.div`
  display: table-cell;
  border-top: solid 1px #ebebeb !important;
  color: #333333;
  width: 62px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;
  text-align: right;
  padding: 12px 16px 12px 16px !important;
  font-size: 13px;
  position: relative;
`;

const StyledDiv = styled.div`
  font-size: 10px;
  margin-bottom: 2px;
`;

interface Props {
  date: string;
  isWide: boolean;
}

export const InquiryListItemDate = (props: Props) => {
  const { date, isWide } = props;

  return isWide ? (
    <StyledTableCell>{formatDate(date)}</StyledTableCell>
  ) : (
    <StyledDiv>{formatDate(date)}</StyledDiv>
  );
};
